import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  width: 100%;
  min-height: 100%;
  padding: 72px;
  overflow: scroll;

  background: #f1f4f5;
`;

export const Header = styled.div`
  margin-bottom: 32px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderLeft = styled.div``;
